import React from 'react'
import PropTypes from 'prop-types'
import ReactLoading from 'react-loading'

import Driver from './Driver'

export default function DriverList (props) {
  const _renderDriver = (driver, index) => {
    return (
      <li key={index}>
        <Driver params={props.params} driver={driver}/>
      </li>
    )
  }

  if(props.drivers.size === 0) {
    return (
      <ReactLoading id="Spin" type={'spin'} color={'#444'}  />
    )
  } else {
    return (
      <div id="driverList">
        <ul className="d-flex flex-wrap justify-content-start">
          {
            !!props.drivers.length ? props.drivers.map(_renderDriver) :
              <p>Este auto no tiene conductores</p>
          }
        </ul>
      </div>
    )
  }
}

DriverList.propTypes = {
  driver: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired
  })
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Drivers/DriverList/index.js